// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessage_message__QLnaj","warn":"ErrorMessage_warn__2BoGK","error":"ErrorMessage_error___h0m1"};